import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SelectableButton } from '../SelectableButton';

export function SupportStep({ value, onChange }: { value?: number; onChange: (value: number) => void }) {
  const { t } = useTranslation('patient-transport');

  return (
    <Stack gap={4}>
      <Typography>{t('reportIncident.steps.support.description')}</Typography>
      <SelectableButton isSelected={value === 1} onClick={() => onChange(1)}>
        1 {t('reportIncident.steps.support.personSingular')}
      </SelectableButton>
      <SelectableButton isSelected={value === 2} onClick={() => onChange(2)}>
        2 {t('reportIncident.steps.support.personPlural')}
      </SelectableButton>
      <SelectableButton isSelected={value === 3} onClick={() => onChange(3)}>
        3 {t('reportIncident.steps.support.personPlural')}
      </SelectableButton>
    </Stack>
  );
}
